import { render } from "./registerGuestPage.vue?vue&type=template&id=54381284"
import script from "./registerGuestPage.vue?vue&type=script&lang=js"
export * from "./registerGuestPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__